import styled from "styled-components"
import media from "@styles/media"

export default styled.div`
  margin: auto;
  padding: ${props => props.noPadding ?? "0 1rem"};
  width: 100%;
  flex-grow: 1;
  background: ${props => props.background};
  z-index: 0;
  position: ${(props) => props.relative ? "relative" : "static"};

  ${media.sm_up`
    max-width: 700px;
  `}

  ${media.md_up`
    max-width: 950px;

    ${props =>
      props.text &&
      `
      max-width: 900px !important;
    `}
  `}
  
  ${media.lg_up`
    max-width: 1200px;
  `}

  ${props =>
    props.hideOverflow &&
    `
    overflow: hidden;
  `}

  ${props =>
    props.blog &&
    `
    max-width: 900px !important;
  `}
  
  ${props =>
    props.fullWidth && {
      maxWidth: "100% !important",
      width: "100%",
    }}
  
  ${props =>
    props.maxWidth && {
      maxWidth: `${props.maxWidth} !important`,
    }}
`
